import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Notification.module.sass";
import Icon from "../../Icon";
import Item from "./Item";
import { getLatestNotifications, hasUnreadNotifications } from "../../../services/notification.service";
import Loader from "../../Loader";
import eventEmitter from "../../../services/event.service";

const Notification = ({ className }) => {
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    const checkUnread = async () => {
      const unread = await hasUnreadNotifications();
      setHasUnread(unread);
    };

    const fetchNotifications = () => {
      setLoading(true);
      getLatestNotifications(5)
        .then((items) => {
          setNotifications(items);
          setLoading(false);
          checkUnread(); // Vérifier après avoir récupéré les notifications
        })
        .catch((err) => {
          console.error("Failed to fetch latest notifications", err);
          setLoading(false);
        });
    };

    checkUnread(); // Vérifier au chargement initial

    if (visible) {
      fetchNotifications();
    }

    const handleUpdate = () => {
      if (visible) {
        fetchNotifications();
      } else {
        checkUnread();
      }
    };

    eventEmitter.subscribe('notificationsUpdated', handleUpdate);

    return () => {
      eventEmitter.unsubscribe('notificationsUpdated', handleUpdate);
    };
  }, [visible]);

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div
        className={cn(styles.notification, className, {
          [styles.active]: visible,
        })}
      >
        <button
          className={cn(styles.head, { [styles.active]: hasUnread })}
          onClick={() => setVisible(!visible)}
        >
          <Icon name="notification" size="24" />
        </button>
        <div className={styles.body}>
          <div className={styles.top}>
            <div className={styles.title}>Notification</div>
          </div>
          <div className={styles.list}>
            {loading ? (
              <Loader />
            ) : (
              notifications.map((x, index) => (
                <Item
                  className={cn(styles.item, className)}
                  item={x}
                  key={index}
                  onClose={() => setVisible(false)}
                />
              ))
            )}
          </div>
          <Link
            className={cn("button", styles.button)}
            to="/admin/notifications"
            onClick={() => setVisible(false)}
          >
            Voir toutes les notifications
          </Link>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Notification;
